module.exports = __webpack_public_path__ + "img/睡.56d2cd25.gif";